export default __webpack_public_path__ + "static/rescue-bots-747eb514d1cc0434ef1c9cfe226e50c5.svg";